var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "json-view-dialog-trigger" },
    [
      _c(
        "el-button",
        {
          attrs: { type: "text", size: "small", disabled: _vm.disabled },
          on: {
            click: function($event) {
              _vm.visible = true
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.hasData ? _vm.buttonText : "-") + "\n  ")]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            width: _vm.dialogWidth,
            "append-to-body": "",
            "before-close": _vm.handleClose,
            "custom-class": "json-view-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            closed: function($event) {
              _vm.visible = false
            }
          }
        },
        [
          _vm.useKeyValueLayout
            ? _c("json-key-value-panel", {
                staticClass: "json-view-dialog-body",
                attrs: {
                  data: _vm.displayValue,
                  "field-labels": _vm.mergedFieldLabels,
                  "field-priority": _vm.fieldPriority
                }
              })
            : _c("json-nested-table", {
                staticClass: "json-view-dialog-body",
                attrs: {
                  data: _vm.content,
                  "view-key": _vm.dataTab,
                  "max-height": _vm.maxHeight
                }
              }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.visible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }